/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthMessagingRouteImport } from './routes/_auth._messaging'
import { Route as AuthBarRouteImport } from './routes/_auth.bar'
import { Route as AuthCalendarRouteImport } from './routes/_auth.calendar'
import { Route as AuthDashboardsRouteImport } from './routes/_auth.dashboards'
import { Route as AuthInboxRouteImport } from './routes/_auth.inbox'
import { Route as AuthInvoicesRouteImport } from './routes/_auth.invoices'
import { Route as AuthMembershipsRouteImport } from './routes/_auth.memberships'
import { Route as AuthPromosRouteImport } from './routes/_auth.promos'
import { Route as AuthRelationsRouteImport } from './routes/_auth.relations'
import { Route as AuthReportsRouteImport } from './routes/_auth.reports'
import { Route as AuthSalesPlanRouteImport } from './routes/_auth.sales-plan'
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings'
import { Route as AuthStaffRouteImport } from './routes/_auth.staff'
import { Route as AuthTodayRouteImport } from './routes/_auth.today'
import { Route as AuthTrainersRouteImport } from './routes/_auth.trainers'
import { Route as AuthTreatmentsRouteImport } from './routes/_auth.treatments'
import { Route as AuthWhatsappRouteImport } from './routes/_auth.whatsapp'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as AuthMessagingAutoMessagesRouteImport } from './routes/_auth._messaging.auto-messages'
import { Route as AuthMessagingGiftsRouteImport } from './routes/_auth._messaging.gifts'
import { Route as AuthMessagingOffersRouteImport } from './routes/_auth._messaging.offers'
import { Route as AuthBookingsIndexRouteImport } from './routes/_auth.bookings.index'
import { Route as AuthBookingsNewRouteImport } from './routes/_auth.bookings.new'
import { Route as AuthClientsIndexRouteImport } from './routes/_auth.clients.index'
import { Route as AuthClientsIdRouteImport } from './routes/_auth.clients.$id'
import { Route as AuthClientsMomentumRouteImport } from './routes/_auth.clients.momentum'
import { Route as AuthClientsStatsRouteImport } from './routes/_auth.clients.stats'
import { Route as AuthClientsTagsRouteImport } from './routes/_auth.clients.tags'
import { Route as AuthClientsTiersRouteImport } from './routes/_auth.clients.tiers'
import { Route as AuthMembershipsIndexRouteImport } from './routes/_auth.memberships.index'
import { Route as AuthMembershipsStatsRouteImport } from './routes/_auth.memberships.stats'
import { Route as AuthRelationsIndexRouteImport } from './routes/_auth.relations.index'
import { Route as AuthRelationsAttendanceRouteImport } from './routes/_auth.relations.attendance'
import { Route as AuthRelationsConsoleRouteImport } from './routes/_auth.relations.console'
import { Route as AuthRelationsDealsRouteImport } from './routes/_auth.relations.deals'
import { Route as AuthRelationsFlowRouteImport } from './routes/_auth.relations.flow'
import { Route as AuthRelationsLogRouteImport } from './routes/_auth.relations.log'
import { Route as AuthRelationsOwnershipRouteImport } from './routes/_auth.relations.ownership'
import { Route as AuthRelationsPriorityRouteImport } from './routes/_auth.relations.priority'
import { Route as AuthRelationsScriptsRouteImport } from './routes/_auth.relations.scripts'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth.settings.index'
import { Route as AuthSettingsBookingRulesRouteImport } from './routes/_auth.settings.booking-rules'
import { Route as AuthSettingsDataQualityRouteImport } from './routes/_auth.settings.data-quality'
import { Route as AuthSettingsPosSyncRouteImport } from './routes/_auth.settings.pos-sync'
import { Route as AuthSettingsRolesRouteImport } from './routes/_auth.settings.roles'
import { Route as AuthSettingsSmsRouteImport } from './routes/_auth.settings.sms'
import { Route as AuthMessagingCampaignsIndexRouteImport } from './routes/_auth._messaging.campaigns.index'
import { Route as AuthMessagingCampaignsIdRouteImport } from './routes/_auth._messaging.campaigns.$id'
import { Route as AuthMessagingSurveysIndexRouteImport } from './routes/_auth._messaging.surveys.index'
import { Route as AuthMessagingSurveysIdRouteImport } from './routes/_auth._messaging.surveys.$id'
import { Route as AuthClientsIdInsightsRouteImport } from './routes/_auth.clients.$id_.insights'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMessagingRoute = AuthMessagingRouteImport.update({
  id: '/_messaging',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBarRoute = AuthBarRouteImport.update({
  id: '/bar',
  path: '/bar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCalendarRoute = AuthCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardsRoute = AuthDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxRoute = AuthInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesRoute = AuthInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMembershipsRoute = AuthMembershipsRouteImport.update({
  id: '/memberships',
  path: '/memberships',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromosRoute = AuthPromosRouteImport.update({
  id: '/promos',
  path: '/promos',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRelationsRoute = AuthRelationsRouteImport.update({
  id: '/relations',
  path: '/relations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsRoute = AuthReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSalesPlanRoute = AuthSalesPlanRouteImport.update({
  id: '/sales-plan',
  path: '/sales-plan',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStaffRoute = AuthStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTodayRoute = AuthTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTrainersRoute = AuthTrainersRouteImport.update({
  id: '/trainers',
  path: '/trainers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTreatmentsRoute = AuthTreatmentsRouteImport.update({
  id: '/treatments',
  path: '/treatments',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWhatsappRoute = AuthWhatsappRouteImport.update({
  id: '/whatsapp',
  path: '/whatsapp',
  getParentRoute: () => AuthRoute,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMessagingAutoMessagesRoute =
  AuthMessagingAutoMessagesRouteImport.update({
    id: '/auto-messages',
    path: '/auto-messages',
    getParentRoute: () => AuthMessagingRoute,
  } as any)
const AuthMessagingGiftsRoute = AuthMessagingGiftsRouteImport.update({
  id: '/gifts',
  path: '/gifts',
  getParentRoute: () => AuthMessagingRoute,
} as any)
const AuthMessagingOffersRoute = AuthMessagingOffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AuthMessagingRoute,
} as any)
const AuthBookingsIndexRoute = AuthBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBookingsNewRoute = AuthBookingsNewRouteImport.update({
  id: '/bookings/new',
  path: '/bookings/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsIndexRoute = AuthClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsIdRoute = AuthClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsMomentumRoute = AuthClientsMomentumRouteImport.update({
  id: '/clients/momentum',
  path: '/clients/momentum',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsStatsRoute = AuthClientsStatsRouteImport.update({
  id: '/clients/stats',
  path: '/clients/stats',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsTagsRoute = AuthClientsTagsRouteImport.update({
  id: '/clients/tags',
  path: '/clients/tags',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsTiersRoute = AuthClientsTiersRouteImport.update({
  id: '/clients/tiers',
  path: '/clients/tiers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMembershipsIndexRoute = AuthMembershipsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMembershipsRoute,
} as any)
const AuthMembershipsStatsRoute = AuthMembershipsStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AuthMembershipsRoute,
} as any)
const AuthRelationsIndexRoute = AuthRelationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsAttendanceRoute = AuthRelationsAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsConsoleRoute = AuthRelationsConsoleRouteImport.update({
  id: '/console',
  path: '/console',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsDealsRoute = AuthRelationsDealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsFlowRoute = AuthRelationsFlowRouteImport.update({
  id: '/flow',
  path: '/flow',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsLogRoute = AuthRelationsLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsOwnershipRoute = AuthRelationsOwnershipRouteImport.update({
  id: '/ownership',
  path: '/ownership',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsPriorityRoute = AuthRelationsPriorityRouteImport.update({
  id: '/priority',
  path: '/priority',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthRelationsScriptsRoute = AuthRelationsScriptsRouteImport.update({
  id: '/scripts',
  path: '/scripts',
  getParentRoute: () => AuthRelationsRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsBookingRulesRoute =
  AuthSettingsBookingRulesRouteImport.update({
    id: '/booking-rules',
    path: '/booking-rules',
    getParentRoute: () => AuthSettingsRoute,
  } as any)
const AuthSettingsDataQualityRoute = AuthSettingsDataQualityRouteImport.update({
  id: '/data-quality',
  path: '/data-quality',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsPosSyncRoute = AuthSettingsPosSyncRouteImport.update({
  id: '/pos-sync',
  path: '/pos-sync',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsRolesRoute = AuthSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsSmsRoute = AuthSettingsSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthMessagingCampaignsIndexRoute =
  AuthMessagingCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthMessagingRoute,
  } as any)
const AuthMessagingCampaignsIdRoute =
  AuthMessagingCampaignsIdRouteImport.update({
    id: '/campaigns/$id',
    path: '/campaigns/$id',
    getParentRoute: () => AuthMessagingRoute,
  } as any)
const AuthMessagingSurveysIndexRoute =
  AuthMessagingSurveysIndexRouteImport.update({
    id: '/surveys/',
    path: '/surveys/',
    getParentRoute: () => AuthMessagingRoute,
  } as any)
const AuthMessagingSurveysIdRoute = AuthMessagingSurveysIdRouteImport.update({
  id: '/surveys/$id',
  path: '/surveys/$id',
  getParentRoute: () => AuthMessagingRoute,
} as any)
const AuthClientsIdInsightsRoute = AuthClientsIdInsightsRouteImport.update({
  id: '/clients/$id_/insights',
  path: '/clients/$id/insights',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/bar': typeof AuthBarRoute
  '/calendar': typeof AuthCalendarRoute
  '/dashboards': typeof AuthDashboardsRoute
  '/inbox': typeof AuthInboxRoute
  '/invoices': typeof AuthInvoicesRoute
  '/memberships': typeof AuthMembershipsRouteWithChildren
  '/promos': typeof AuthPromosRoute
  '/relations': typeof AuthRelationsRouteWithChildren
  '/reports': typeof AuthReportsRoute
  '/sales-plan': typeof AuthSalesPlanRoute
  '/settings': typeof AuthSettingsRouteWithChildren
  '/staff': typeof AuthStaffRoute
  '/today': typeof AuthTodayRoute
  '/trainers': typeof AuthTrainersRoute
  '/treatments': typeof AuthTreatmentsRoute
  '/whatsapp': typeof AuthWhatsappRoute
  '/s/$token': typeof STokenRoute
  '/auto-messages': typeof AuthMessagingAutoMessagesRoute
  '/gifts': typeof AuthMessagingGiftsRoute
  '/offers': typeof AuthMessagingOffersRoute
  '/bookings/new': typeof AuthBookingsNewRoute
  '/clients/$id': typeof AuthClientsIdRoute
  '/clients/momentum': typeof AuthClientsMomentumRoute
  '/clients/stats': typeof AuthClientsStatsRoute
  '/clients/tags': typeof AuthClientsTagsRoute
  '/clients/tiers': typeof AuthClientsTiersRoute
  '/memberships/stats': typeof AuthMembershipsStatsRoute
  '/relations/attendance': typeof AuthRelationsAttendanceRoute
  '/relations/console': typeof AuthRelationsConsoleRoute
  '/relations/deals': typeof AuthRelationsDealsRoute
  '/relations/flow': typeof AuthRelationsFlowRoute
  '/relations/log': typeof AuthRelationsLogRoute
  '/relations/ownership': typeof AuthRelationsOwnershipRoute
  '/relations/priority': typeof AuthRelationsPriorityRoute
  '/relations/scripts': typeof AuthRelationsScriptsRoute
  '/settings/booking-rules': typeof AuthSettingsBookingRulesRoute
  '/settings/data-quality': typeof AuthSettingsDataQualityRoute
  '/settings/pos-sync': typeof AuthSettingsPosSyncRoute
  '/settings/roles': typeof AuthSettingsRolesRoute
  '/settings/sms': typeof AuthSettingsSmsRoute
  '/bookings/': typeof AuthBookingsIndexRoute
  '/clients/': typeof AuthClientsIndexRoute
  '/memberships/': typeof AuthMembershipsIndexRoute
  '/relations/': typeof AuthRelationsIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
  '/campaigns/$id': typeof AuthMessagingCampaignsIdRoute
  '/surveys/$id': typeof AuthMessagingSurveysIdRoute
  '/clients/$id/insights': typeof AuthClientsIdInsightsRoute
  '/campaigns/': typeof AuthMessagingCampaignsIndexRoute
  '/surveys/': typeof AuthMessagingSurveysIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthIndexRoute
  '/bar': typeof AuthBarRoute
  '/calendar': typeof AuthCalendarRoute
  '/dashboards': typeof AuthDashboardsRoute
  '/inbox': typeof AuthInboxRoute
  '/invoices': typeof AuthInvoicesRoute
  '/promos': typeof AuthPromosRoute
  '/reports': typeof AuthReportsRoute
  '/sales-plan': typeof AuthSalesPlanRoute
  '/staff': typeof AuthStaffRoute
  '/today': typeof AuthTodayRoute
  '/trainers': typeof AuthTrainersRoute
  '/treatments': typeof AuthTreatmentsRoute
  '/whatsapp': typeof AuthWhatsappRoute
  '/s/$token': typeof STokenRoute
  '/auto-messages': typeof AuthMessagingAutoMessagesRoute
  '/gifts': typeof AuthMessagingGiftsRoute
  '/offers': typeof AuthMessagingOffersRoute
  '/bookings/new': typeof AuthBookingsNewRoute
  '/clients/$id': typeof AuthClientsIdRoute
  '/clients/momentum': typeof AuthClientsMomentumRoute
  '/clients/stats': typeof AuthClientsStatsRoute
  '/clients/tags': typeof AuthClientsTagsRoute
  '/clients/tiers': typeof AuthClientsTiersRoute
  '/memberships/stats': typeof AuthMembershipsStatsRoute
  '/relations/attendance': typeof AuthRelationsAttendanceRoute
  '/relations/console': typeof AuthRelationsConsoleRoute
  '/relations/deals': typeof AuthRelationsDealsRoute
  '/relations/flow': typeof AuthRelationsFlowRoute
  '/relations/log': typeof AuthRelationsLogRoute
  '/relations/ownership': typeof AuthRelationsOwnershipRoute
  '/relations/priority': typeof AuthRelationsPriorityRoute
  '/relations/scripts': typeof AuthRelationsScriptsRoute
  '/settings/booking-rules': typeof AuthSettingsBookingRulesRoute
  '/settings/data-quality': typeof AuthSettingsDataQualityRoute
  '/settings/pos-sync': typeof AuthSettingsPosSyncRoute
  '/settings/roles': typeof AuthSettingsRolesRoute
  '/settings/sms': typeof AuthSettingsSmsRoute
  '/bookings': typeof AuthBookingsIndexRoute
  '/clients': typeof AuthClientsIndexRoute
  '/memberships': typeof AuthMembershipsIndexRoute
  '/relations': typeof AuthRelationsIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/campaigns/$id': typeof AuthMessagingCampaignsIdRoute
  '/surveys/$id': typeof AuthMessagingSurveysIdRoute
  '/clients/$id/insights': typeof AuthClientsIdInsightsRoute
  '/campaigns': typeof AuthMessagingCampaignsIndexRoute
  '/surveys': typeof AuthMessagingSurveysIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/_messaging': typeof AuthMessagingRouteWithChildren
  '/_auth/bar': typeof AuthBarRoute
  '/_auth/calendar': typeof AuthCalendarRoute
  '/_auth/dashboards': typeof AuthDashboardsRoute
  '/_auth/inbox': typeof AuthInboxRoute
  '/_auth/invoices': typeof AuthInvoicesRoute
  '/_auth/memberships': typeof AuthMembershipsRouteWithChildren
  '/_auth/promos': typeof AuthPromosRoute
  '/_auth/relations': typeof AuthRelationsRouteWithChildren
  '/_auth/reports': typeof AuthReportsRoute
  '/_auth/sales-plan': typeof AuthSalesPlanRoute
  '/_auth/settings': typeof AuthSettingsRouteWithChildren
  '/_auth/staff': typeof AuthStaffRoute
  '/_auth/today': typeof AuthTodayRoute
  '/_auth/trainers': typeof AuthTrainersRoute
  '/_auth/treatments': typeof AuthTreatmentsRoute
  '/_auth/whatsapp': typeof AuthWhatsappRoute
  '/s/$token': typeof STokenRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/_messaging/auto-messages': typeof AuthMessagingAutoMessagesRoute
  '/_auth/_messaging/gifts': typeof AuthMessagingGiftsRoute
  '/_auth/_messaging/offers': typeof AuthMessagingOffersRoute
  '/_auth/bookings/new': typeof AuthBookingsNewRoute
  '/_auth/clients/$id': typeof AuthClientsIdRoute
  '/_auth/clients/momentum': typeof AuthClientsMomentumRoute
  '/_auth/clients/stats': typeof AuthClientsStatsRoute
  '/_auth/clients/tags': typeof AuthClientsTagsRoute
  '/_auth/clients/tiers': typeof AuthClientsTiersRoute
  '/_auth/memberships/stats': typeof AuthMembershipsStatsRoute
  '/_auth/relations/attendance': typeof AuthRelationsAttendanceRoute
  '/_auth/relations/console': typeof AuthRelationsConsoleRoute
  '/_auth/relations/deals': typeof AuthRelationsDealsRoute
  '/_auth/relations/flow': typeof AuthRelationsFlowRoute
  '/_auth/relations/log': typeof AuthRelationsLogRoute
  '/_auth/relations/ownership': typeof AuthRelationsOwnershipRoute
  '/_auth/relations/priority': typeof AuthRelationsPriorityRoute
  '/_auth/relations/scripts': typeof AuthRelationsScriptsRoute
  '/_auth/settings/booking-rules': typeof AuthSettingsBookingRulesRoute
  '/_auth/settings/data-quality': typeof AuthSettingsDataQualityRoute
  '/_auth/settings/pos-sync': typeof AuthSettingsPosSyncRoute
  '/_auth/settings/roles': typeof AuthSettingsRolesRoute
  '/_auth/settings/sms': typeof AuthSettingsSmsRoute
  '/_auth/bookings/': typeof AuthBookingsIndexRoute
  '/_auth/clients/': typeof AuthClientsIndexRoute
  '/_auth/memberships/': typeof AuthMembershipsIndexRoute
  '/_auth/relations/': typeof AuthRelationsIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/_messaging/campaigns/$id': typeof AuthMessagingCampaignsIdRoute
  '/_auth/_messaging/surveys/$id': typeof AuthMessagingSurveysIdRoute
  '/_auth/clients/$id_/insights': typeof AuthClientsIdInsightsRoute
  '/_auth/_messaging/campaigns/': typeof AuthMessagingCampaignsIndexRoute
  '/_auth/_messaging/surveys/': typeof AuthMessagingSurveysIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/bar'
    | '/calendar'
    | '/dashboards'
    | '/inbox'
    | '/invoices'
    | '/memberships'
    | '/promos'
    | '/relations'
    | '/reports'
    | '/sales-plan'
    | '/settings'
    | '/staff'
    | '/today'
    | '/trainers'
    | '/treatments'
    | '/whatsapp'
    | '/s/$token'
    | '/auto-messages'
    | '/gifts'
    | '/offers'
    | '/bookings/new'
    | '/clients/$id'
    | '/clients/momentum'
    | '/clients/stats'
    | '/clients/tags'
    | '/clients/tiers'
    | '/memberships/stats'
    | '/relations/attendance'
    | '/relations/console'
    | '/relations/deals'
    | '/relations/flow'
    | '/relations/log'
    | '/relations/ownership'
    | '/relations/priority'
    | '/relations/scripts'
    | '/settings/booking-rules'
    | '/settings/data-quality'
    | '/settings/pos-sync'
    | '/settings/roles'
    | '/settings/sms'
    | '/bookings/'
    | '/clients/'
    | '/memberships/'
    | '/relations/'
    | '/settings/'
    | '/campaigns/$id'
    | '/surveys/$id'
    | '/clients/$id/insights'
    | '/campaigns/'
    | '/surveys/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/bar'
    | '/calendar'
    | '/dashboards'
    | '/inbox'
    | '/invoices'
    | '/promos'
    | '/reports'
    | '/sales-plan'
    | '/staff'
    | '/today'
    | '/trainers'
    | '/treatments'
    | '/whatsapp'
    | '/s/$token'
    | '/auto-messages'
    | '/gifts'
    | '/offers'
    | '/bookings/new'
    | '/clients/$id'
    | '/clients/momentum'
    | '/clients/stats'
    | '/clients/tags'
    | '/clients/tiers'
    | '/memberships/stats'
    | '/relations/attendance'
    | '/relations/console'
    | '/relations/deals'
    | '/relations/flow'
    | '/relations/log'
    | '/relations/ownership'
    | '/relations/priority'
    | '/relations/scripts'
    | '/settings/booking-rules'
    | '/settings/data-quality'
    | '/settings/pos-sync'
    | '/settings/roles'
    | '/settings/sms'
    | '/bookings'
    | '/clients'
    | '/memberships'
    | '/relations'
    | '/settings'
    | '/campaigns/$id'
    | '/surveys/$id'
    | '/clients/$id/insights'
    | '/campaigns'
    | '/surveys'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/_messaging'
    | '/_auth/bar'
    | '/_auth/calendar'
    | '/_auth/dashboards'
    | '/_auth/inbox'
    | '/_auth/invoices'
    | '/_auth/memberships'
    | '/_auth/promos'
    | '/_auth/relations'
    | '/_auth/reports'
    | '/_auth/sales-plan'
    | '/_auth/settings'
    | '/_auth/staff'
    | '/_auth/today'
    | '/_auth/trainers'
    | '/_auth/treatments'
    | '/_auth/whatsapp'
    | '/s/$token'
    | '/_auth/'
    | '/_auth/_messaging/auto-messages'
    | '/_auth/_messaging/gifts'
    | '/_auth/_messaging/offers'
    | '/_auth/bookings/new'
    | '/_auth/clients/$id'
    | '/_auth/clients/momentum'
    | '/_auth/clients/stats'
    | '/_auth/clients/tags'
    | '/_auth/clients/tiers'
    | '/_auth/memberships/stats'
    | '/_auth/relations/attendance'
    | '/_auth/relations/console'
    | '/_auth/relations/deals'
    | '/_auth/relations/flow'
    | '/_auth/relations/log'
    | '/_auth/relations/ownership'
    | '/_auth/relations/priority'
    | '/_auth/relations/scripts'
    | '/_auth/settings/booking-rules'
    | '/_auth/settings/data-quality'
    | '/_auth/settings/pos-sync'
    | '/_auth/settings/roles'
    | '/_auth/settings/sms'
    | '/_auth/bookings/'
    | '/_auth/clients/'
    | '/_auth/memberships/'
    | '/_auth/relations/'
    | '/_auth/settings/'
    | '/_auth/_messaging/campaigns/$id'
    | '/_auth/_messaging/surveys/$id'
    | '/_auth/clients/$id_/insights'
    | '/_auth/_messaging/campaigns/'
    | '/_auth/_messaging/surveys/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_messaging': {
      id: '/_auth/_messaging'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthMessagingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bar': {
      id: '/_auth/bar'
      path: '/bar'
      fullPath: '/bar'
      preLoaderRoute: typeof AuthBarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/calendar': {
      id: '/_auth/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthCalendarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards': {
      id: '/_auth/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof AuthDashboardsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox': {
      id: '/_auth/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthInboxRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices': {
      id: '/_auth/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthInvoicesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/memberships': {
      id: '/_auth/memberships'
      path: '/memberships'
      fullPath: '/memberships'
      preLoaderRoute: typeof AuthMembershipsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promos': {
      id: '/_auth/promos'
      path: '/promos'
      fullPath: '/promos'
      preLoaderRoute: typeof AuthPromosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/relations': {
      id: '/_auth/relations'
      path: '/relations'
      fullPath: '/relations'
      preLoaderRoute: typeof AuthRelationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sales-plan': {
      id: '/_auth/sales-plan'
      path: '/sales-plan'
      fullPath: '/sales-plan'
      preLoaderRoute: typeof AuthSalesPlanRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/staff': {
      id: '/_auth/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthStaffRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/today': {
      id: '/_auth/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AuthTodayRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/trainers': {
      id: '/_auth/trainers'
      path: '/trainers'
      fullPath: '/trainers'
      preLoaderRoute: typeof AuthTrainersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/treatments': {
      id: '/_auth/treatments'
      path: '/treatments'
      fullPath: '/treatments'
      preLoaderRoute: typeof AuthTreatmentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/whatsapp': {
      id: '/_auth/whatsapp'
      path: '/whatsapp'
      fullPath: '/whatsapp'
      preLoaderRoute: typeof AuthWhatsappRouteImport
      parentRoute: typeof AuthRoute
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_messaging/auto-messages': {
      id: '/_auth/_messaging/auto-messages'
      path: '/auto-messages'
      fullPath: '/auto-messages'
      preLoaderRoute: typeof AuthMessagingAutoMessagesRouteImport
      parentRoute: typeof AuthMessagingRoute
    }
    '/_auth/_messaging/gifts': {
      id: '/_auth/_messaging/gifts'
      path: '/gifts'
      fullPath: '/gifts'
      preLoaderRoute: typeof AuthMessagingGiftsRouteImport
      parentRoute: typeof AuthMessagingRoute
    }
    '/_auth/_messaging/offers': {
      id: '/_auth/_messaging/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof AuthMessagingOffersRouteImport
      parentRoute: typeof AuthMessagingRoute
    }
    '/_auth/bookings/': {
      id: '/_auth/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AuthBookingsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bookings/new': {
      id: '/_auth/bookings/new'
      path: '/bookings/new'
      fullPath: '/bookings/new'
      preLoaderRoute: typeof AuthBookingsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/': {
      id: '/_auth/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthClientsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/$id': {
      id: '/_auth/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof AuthClientsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/momentum': {
      id: '/_auth/clients/momentum'
      path: '/clients/momentum'
      fullPath: '/clients/momentum'
      preLoaderRoute: typeof AuthClientsMomentumRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/stats': {
      id: '/_auth/clients/stats'
      path: '/clients/stats'
      fullPath: '/clients/stats'
      preLoaderRoute: typeof AuthClientsStatsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/tags': {
      id: '/_auth/clients/tags'
      path: '/clients/tags'
      fullPath: '/clients/tags'
      preLoaderRoute: typeof AuthClientsTagsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/tiers': {
      id: '/_auth/clients/tiers'
      path: '/clients/tiers'
      fullPath: '/clients/tiers'
      preLoaderRoute: typeof AuthClientsTiersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/memberships/': {
      id: '/_auth/memberships/'
      path: '/'
      fullPath: '/memberships/'
      preLoaderRoute: typeof AuthMembershipsIndexRouteImport
      parentRoute: typeof AuthMembershipsRoute
    }
    '/_auth/memberships/stats': {
      id: '/_auth/memberships/stats'
      path: '/stats'
      fullPath: '/memberships/stats'
      preLoaderRoute: typeof AuthMembershipsStatsRouteImport
      parentRoute: typeof AuthMembershipsRoute
    }
    '/_auth/relations/': {
      id: '/_auth/relations/'
      path: '/'
      fullPath: '/relations/'
      preLoaderRoute: typeof AuthRelationsIndexRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/attendance': {
      id: '/_auth/relations/attendance'
      path: '/attendance'
      fullPath: '/relations/attendance'
      preLoaderRoute: typeof AuthRelationsAttendanceRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/console': {
      id: '/_auth/relations/console'
      path: '/console'
      fullPath: '/relations/console'
      preLoaderRoute: typeof AuthRelationsConsoleRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/deals': {
      id: '/_auth/relations/deals'
      path: '/deals'
      fullPath: '/relations/deals'
      preLoaderRoute: typeof AuthRelationsDealsRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/flow': {
      id: '/_auth/relations/flow'
      path: '/flow'
      fullPath: '/relations/flow'
      preLoaderRoute: typeof AuthRelationsFlowRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/log': {
      id: '/_auth/relations/log'
      path: '/log'
      fullPath: '/relations/log'
      preLoaderRoute: typeof AuthRelationsLogRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/ownership': {
      id: '/_auth/relations/ownership'
      path: '/ownership'
      fullPath: '/relations/ownership'
      preLoaderRoute: typeof AuthRelationsOwnershipRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/priority': {
      id: '/_auth/relations/priority'
      path: '/priority'
      fullPath: '/relations/priority'
      preLoaderRoute: typeof AuthRelationsPriorityRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/relations/scripts': {
      id: '/_auth/relations/scripts'
      path: '/scripts'
      fullPath: '/relations/scripts'
      preLoaderRoute: typeof AuthRelationsScriptsRouteImport
      parentRoute: typeof AuthRelationsRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/booking-rules': {
      id: '/_auth/settings/booking-rules'
      path: '/booking-rules'
      fullPath: '/settings/booking-rules'
      preLoaderRoute: typeof AuthSettingsBookingRulesRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/data-quality': {
      id: '/_auth/settings/data-quality'
      path: '/data-quality'
      fullPath: '/settings/data-quality'
      preLoaderRoute: typeof AuthSettingsDataQualityRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/pos-sync': {
      id: '/_auth/settings/pos-sync'
      path: '/pos-sync'
      fullPath: '/settings/pos-sync'
      preLoaderRoute: typeof AuthSettingsPosSyncRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/roles': {
      id: '/_auth/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthSettingsRolesRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/sms': {
      id: '/_auth/settings/sms'
      path: '/sms'
      fullPath: '/settings/sms'
      preLoaderRoute: typeof AuthSettingsSmsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/_messaging/campaigns/': {
      id: '/_auth/_messaging/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthMessagingCampaignsIndexRouteImport
      parentRoute: typeof AuthMessagingRoute
    }
    '/_auth/_messaging/campaigns/$id': {
      id: '/_auth/_messaging/campaigns/$id'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof AuthMessagingCampaignsIdRouteImport
      parentRoute: typeof AuthMessagingRoute
    }
    '/_auth/_messaging/surveys/': {
      id: '/_auth/_messaging/surveys/'
      path: '/surveys'
      fullPath: '/surveys/'
      preLoaderRoute: typeof AuthMessagingSurveysIndexRouteImport
      parentRoute: typeof AuthMessagingRoute
    }
    '/_auth/_messaging/surveys/$id': {
      id: '/_auth/_messaging/surveys/$id'
      path: '/surveys/$id'
      fullPath: '/surveys/$id'
      preLoaderRoute: typeof AuthMessagingSurveysIdRouteImport
      parentRoute: typeof AuthMessagingRoute
    }
    '/_auth/clients/$id_/insights': {
      id: '/_auth/clients/$id_/insights'
      path: '/clients/$id/insights'
      fullPath: '/clients/$id/insights'
      preLoaderRoute: typeof AuthClientsIdInsightsRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthMessagingRouteChildren {
  AuthMessagingAutoMessagesRoute: typeof AuthMessagingAutoMessagesRoute
  AuthMessagingGiftsRoute: typeof AuthMessagingGiftsRoute
  AuthMessagingOffersRoute: typeof AuthMessagingOffersRoute
  AuthMessagingCampaignsIdRoute: typeof AuthMessagingCampaignsIdRoute
  AuthMessagingSurveysIdRoute: typeof AuthMessagingSurveysIdRoute
  AuthMessagingCampaignsIndexRoute: typeof AuthMessagingCampaignsIndexRoute
  AuthMessagingSurveysIndexRoute: typeof AuthMessagingSurveysIndexRoute
}

const AuthMessagingRouteChildren: AuthMessagingRouteChildren = {
  AuthMessagingAutoMessagesRoute: AuthMessagingAutoMessagesRoute,
  AuthMessagingGiftsRoute: AuthMessagingGiftsRoute,
  AuthMessagingOffersRoute: AuthMessagingOffersRoute,
  AuthMessagingCampaignsIdRoute: AuthMessagingCampaignsIdRoute,
  AuthMessagingSurveysIdRoute: AuthMessagingSurveysIdRoute,
  AuthMessagingCampaignsIndexRoute: AuthMessagingCampaignsIndexRoute,
  AuthMessagingSurveysIndexRoute: AuthMessagingSurveysIndexRoute,
}

const AuthMessagingRouteWithChildren = AuthMessagingRoute._addFileChildren(
  AuthMessagingRouteChildren,
)

interface AuthMembershipsRouteChildren {
  AuthMembershipsStatsRoute: typeof AuthMembershipsStatsRoute
  AuthMembershipsIndexRoute: typeof AuthMembershipsIndexRoute
}

const AuthMembershipsRouteChildren: AuthMembershipsRouteChildren = {
  AuthMembershipsStatsRoute: AuthMembershipsStatsRoute,
  AuthMembershipsIndexRoute: AuthMembershipsIndexRoute,
}

const AuthMembershipsRouteWithChildren = AuthMembershipsRoute._addFileChildren(
  AuthMembershipsRouteChildren,
)

interface AuthRelationsRouteChildren {
  AuthRelationsAttendanceRoute: typeof AuthRelationsAttendanceRoute
  AuthRelationsConsoleRoute: typeof AuthRelationsConsoleRoute
  AuthRelationsDealsRoute: typeof AuthRelationsDealsRoute
  AuthRelationsFlowRoute: typeof AuthRelationsFlowRoute
  AuthRelationsLogRoute: typeof AuthRelationsLogRoute
  AuthRelationsOwnershipRoute: typeof AuthRelationsOwnershipRoute
  AuthRelationsPriorityRoute: typeof AuthRelationsPriorityRoute
  AuthRelationsScriptsRoute: typeof AuthRelationsScriptsRoute
  AuthRelationsIndexRoute: typeof AuthRelationsIndexRoute
}

const AuthRelationsRouteChildren: AuthRelationsRouteChildren = {
  AuthRelationsAttendanceRoute: AuthRelationsAttendanceRoute,
  AuthRelationsConsoleRoute: AuthRelationsConsoleRoute,
  AuthRelationsDealsRoute: AuthRelationsDealsRoute,
  AuthRelationsFlowRoute: AuthRelationsFlowRoute,
  AuthRelationsLogRoute: AuthRelationsLogRoute,
  AuthRelationsOwnershipRoute: AuthRelationsOwnershipRoute,
  AuthRelationsPriorityRoute: AuthRelationsPriorityRoute,
  AuthRelationsScriptsRoute: AuthRelationsScriptsRoute,
  AuthRelationsIndexRoute: AuthRelationsIndexRoute,
}

const AuthRelationsRouteWithChildren = AuthRelationsRoute._addFileChildren(
  AuthRelationsRouteChildren,
)

interface AuthSettingsRouteChildren {
  AuthSettingsBookingRulesRoute: typeof AuthSettingsBookingRulesRoute
  AuthSettingsDataQualityRoute: typeof AuthSettingsDataQualityRoute
  AuthSettingsPosSyncRoute: typeof AuthSettingsPosSyncRoute
  AuthSettingsRolesRoute: typeof AuthSettingsRolesRoute
  AuthSettingsSmsRoute: typeof AuthSettingsSmsRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
}

const AuthSettingsRouteChildren: AuthSettingsRouteChildren = {
  AuthSettingsBookingRulesRoute: AuthSettingsBookingRulesRoute,
  AuthSettingsDataQualityRoute: AuthSettingsDataQualityRoute,
  AuthSettingsPosSyncRoute: AuthSettingsPosSyncRoute,
  AuthSettingsRolesRoute: AuthSettingsRolesRoute,
  AuthSettingsSmsRoute: AuthSettingsSmsRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
}

const AuthSettingsRouteWithChildren = AuthSettingsRoute._addFileChildren(
  AuthSettingsRouteChildren,
)

interface AuthRouteChildren {
  AuthMessagingRoute: typeof AuthMessagingRouteWithChildren
  AuthBarRoute: typeof AuthBarRoute
  AuthCalendarRoute: typeof AuthCalendarRoute
  AuthDashboardsRoute: typeof AuthDashboardsRoute
  AuthInboxRoute: typeof AuthInboxRoute
  AuthInvoicesRoute: typeof AuthInvoicesRoute
  AuthMembershipsRoute: typeof AuthMembershipsRouteWithChildren
  AuthPromosRoute: typeof AuthPromosRoute
  AuthRelationsRoute: typeof AuthRelationsRouteWithChildren
  AuthReportsRoute: typeof AuthReportsRoute
  AuthSalesPlanRoute: typeof AuthSalesPlanRoute
  AuthSettingsRoute: typeof AuthSettingsRouteWithChildren
  AuthStaffRoute: typeof AuthStaffRoute
  AuthTodayRoute: typeof AuthTodayRoute
  AuthTrainersRoute: typeof AuthTrainersRoute
  AuthTreatmentsRoute: typeof AuthTreatmentsRoute
  AuthWhatsappRoute: typeof AuthWhatsappRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthBookingsNewRoute: typeof AuthBookingsNewRoute
  AuthClientsIdRoute: typeof AuthClientsIdRoute
  AuthClientsMomentumRoute: typeof AuthClientsMomentumRoute
  AuthClientsStatsRoute: typeof AuthClientsStatsRoute
  AuthClientsTagsRoute: typeof AuthClientsTagsRoute
  AuthClientsTiersRoute: typeof AuthClientsTiersRoute
  AuthBookingsIndexRoute: typeof AuthBookingsIndexRoute
  AuthClientsIndexRoute: typeof AuthClientsIndexRoute
  AuthClientsIdInsightsRoute: typeof AuthClientsIdInsightsRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthMessagingRoute: AuthMessagingRouteWithChildren,
  AuthBarRoute: AuthBarRoute,
  AuthCalendarRoute: AuthCalendarRoute,
  AuthDashboardsRoute: AuthDashboardsRoute,
  AuthInboxRoute: AuthInboxRoute,
  AuthInvoicesRoute: AuthInvoicesRoute,
  AuthMembershipsRoute: AuthMembershipsRouteWithChildren,
  AuthPromosRoute: AuthPromosRoute,
  AuthRelationsRoute: AuthRelationsRouteWithChildren,
  AuthReportsRoute: AuthReportsRoute,
  AuthSalesPlanRoute: AuthSalesPlanRoute,
  AuthSettingsRoute: AuthSettingsRouteWithChildren,
  AuthStaffRoute: AuthStaffRoute,
  AuthTodayRoute: AuthTodayRoute,
  AuthTrainersRoute: AuthTrainersRoute,
  AuthTreatmentsRoute: AuthTreatmentsRoute,
  AuthWhatsappRoute: AuthWhatsappRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthBookingsNewRoute: AuthBookingsNewRoute,
  AuthClientsIdRoute: AuthClientsIdRoute,
  AuthClientsMomentumRoute: AuthClientsMomentumRoute,
  AuthClientsStatsRoute: AuthClientsStatsRoute,
  AuthClientsTagsRoute: AuthClientsTagsRoute,
  AuthClientsTiersRoute: AuthClientsTiersRoute,
  AuthBookingsIndexRoute: AuthBookingsIndexRoute,
  AuthClientsIndexRoute: AuthClientsIndexRoute,
  AuthClientsIdInsightsRoute: AuthClientsIdInsightsRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
